export const ApiBaseUrl2 = "https://localhost:5001/";
export const ApiBaseUrl = "https://meta-api.khalidelewa.com/";
